import { useReactRouter } from '@hooks/useRouter';
import { useToggle } from '@hooks/useToggle';
import { useApi } from '@model/utils/useApi';
import { route } from '@packages/router';

export function useDuplicateOrder() {
    const { history } = useReactRouter();
    const duplicating = useToggle();
    const createOrderApi$ = useApi({ url: '/apparel-orders/move-iq-forward' });

    const handleDuplicateOrder = (order) => async () => {
        duplicating.setState(true);
        try {
            const config = {
                data: order,
                params: {
                    fields: ['id', 'name', 'salesman', 'customer', 'total'],
                },
            };
            const { data } = await createOrderApi$.save(config);

            history.push(route('Order.Create', { tab: 'designs', order: data.id }));
        } catch (e) {
            // Do nothing
        }

        duplicating.setState(false);
    };

    return {
        handleDuplicateOrder,
        isDuplicating: duplicating.state,
    };
}
